import { useState } from "react";
import { toast } from "sonner";
import { usePage } from "../../hooks/usePage";
import { useSite } from "../../context/SiteContext";
import { Loading, PageHero } from "../../components/site/Blocks";
import { api, errMsg } from "../../lib/api";
import { SNAPSHOT, SnapshotNotice } from "../../lib/snapshot";

const EMPTY = { name: "", email: "", subject: "", message: "" };

const Field = ({ id, label, required, textarea, ...props }) => (
  <div>
    <label htmlFor={id} className="field-label">{label}{required && <span className="text-burgundy"> *</span>}</label>
    {textarea ? <textarea id={id} rows={6} required={required} className="field-input" {...props} />
      : <input id={id} required={required} className="field-input" {...props} />}
  </div>
);

export default function Contact() {
  const { section, loading } = usePage("contact");
  const { settings } = useSite();
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  if (loading) return <Loading />;
  const intro = section("intro");
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/public/contact", form); setSent(true); setForm(EMPTY); }
    catch (err) { toast.error(errMsg(err)); }
    finally { setBusy(false); }
  };

  return (
    <div data-testid="contact-page">
      {intro && <PageHero eyebrow={intro.eyebrow} title={intro.heading} subtitle={intro.body} />}
      <section className="container-site grid gap-12 py-16 lg:grid-cols-3">
        <form onSubmit={submit} className="space-y-5 lg:col-span-2" data-testid="contact-form" noValidate={false}>
          <SnapshotNotice />
          {sent && <p role="status" className="rounded bg-paleblue p-4 font-semibold text-navy" data-testid="contact-success">Thank you. Your message has been received.</p>}
          <div className="grid gap-5 sm:grid-cols-2">
            <Field id="c-name" label="Name" required value={form.name} onChange={set("name")} data-testid="contact-name-input" />
            <Field id="c-email" label="Email" type="email" required value={form.email} onChange={set("email")} data-testid="contact-email-input" />
          </div>
          <Field id="c-subject" label="Subject" value={form.subject} onChange={set("subject")} data-testid="contact-subject-input" />
          <Field id="c-message" label="Message" required textarea minLength={5} value={form.message} onChange={set("message")} data-testid="contact-message-input" />
          <button type="submit" className="btn-primary" disabled={busy || SNAPSHOT} data-testid="contact-submit-btn">{busy ? "Sending…" : "Send Message"}</button>
        </form>
        <aside className="rounded-lg bg-paleblue p-6" data-testid="contact-details">
          <h2 className="text-xl text-navy">CIArb Bahamas Branch</h2>
          <dl className="mt-4 space-y-3 text-[#4A5568]">
            {settings.contact_email && <div><dt className="font-semibold text-navy">Email</dt><dd>{settings.contact_email}</dd></div>}
            {settings.contact_phone && <div><dt className="font-semibold text-navy">Phone</dt><dd>{settings.contact_phone}</dd></div>}
            {settings.contact_address && <div><dt className="font-semibold text-navy">Address</dt><dd>{settings.contact_address}</dd></div>}
            {!settings.contact_email && !settings.contact_phone && <dd>Contact details will be published soon. Please use the form.</dd>}
          </dl>
        </aside>
      </section>
    </div>
  );
}
